import { ExtraOptions, PreloadAllModules } from '@angular/router';

export const appRouterOptions: ExtraOptions = {
  preloadingStrategy: PreloadAllModules,
  canceledNavigationResolution: 'computed',
};
